import { useState } from 'react';
import * as Tone from 'tone';

const MusicPlayer = ({musicData, parentOnDone}) => {
    const [playing, setPlaying] = useState(false)

    const valueToNote = (value) => {
        const scale = ['C4', 'C#4', 'D4', 'D#4', 'E4', 'F4', 'F#4', 'G4', 'G#4', 'A4', 'A#4', 'B4', 'C5']
        return scale[value % 13]
    }

    const onDone = () => {
        setPlaying(false)
        parentOnDone()
    }

    const playMusic = async () => {
        if (playing) {
          return;
        }
        setPlaying(true);
        await Tone.start(); // Start AudioContext
      
        // Stop and reset transport
        Tone.Transport.stop();
        Tone.Transport.cancel();
        Tone.Transport.position = 0;
      
        const synth = new Tone.Synth().toDestination();
      
        // Create a crisp noise-based metronome click
        const metronome = new Tone.NoiseSynth({
          noise: { type: "white" },
          envelope: {
            attack: 0.001,
            decay: 0.05,
            sustain: 0,
          },
        }).toDestination();
      
        const bpm = musicData.bpm;
        const secondsPerBeat = 60 / bpm;
      
        Tone.Transport.bpm.value = bpm;
      
        let currentTime = 0;

        let metronomeBeat = {value: -2, duration: 1};
      
        // Total hack to get four beats lead in
        [metronomeBeat, metronomeBeat, metronomeBeat, metronomeBeat, ...musicData.notes].forEach((note) => {
          const durationInBeats = note.duration;
          const durationInSeconds = durationInBeats * secondsPerBeat;
      
          if (note.value == -2) {
            metronome.triggerAttackRelease(durationInSeconds, currentTime);
          }
          else if (note.value !== -1) {
            const pitch = valueToNote(note.value);
            synth.triggerAttackRelease(pitch, durationInSeconds, currentTime);
          }
      
          currentTime += durationInSeconds;
        });
      
        // Schedule callback for when music finishes
        Tone.Transport.schedule(() => {
            synth.disconnect()
            onDone();
        }, currentTime);
      
        // Start playback
        Tone.Transport.start();
      };

      return (
        <div style={{justifyContent: 'center', borderColor: '#000000', borderWidth: 1}}>
            <p onClick={() => playMusic()} style={{fontSize: 100, cursor: 'pointer', width: '20%', alignSelf: 'center'}}>{(playing)? '' : '▶'}</p>
        </div>
      )
}

export default MusicPlayer